import { useMemo } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { KeywordViewStore } from 'pages/keywords/store'
import { KeywordViewContext } from 'pages/keywords/context'
import { KeywordViewContent } from 'pages/keywords/pages/createKeyword/ui/KeywordViewContent'

export const CreateKeyword = () => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new KeywordViewStore(entities), [])

  return (
    <KeywordViewContext.Provider value={store}>
      <KeywordViewContent />
    </KeywordViewContext.Provider>
  )
}
